<template>
  <div>
	  <div class="ui segments">
			<div class="ui segment">
				<h3 class="ui header">{{ $t('pages.bookings.available_bookings') }}</h3>
			</div>

			<div class="ui segment" v-for="booking in bookings.data" :key="booking.id" v-if="!fetchError">
				<div class="ui two column middle aligned grid">
					<div class="sixteen wide mobile eight wide tablet eight wide computer left aligned column">
						{{ booking.product.name }}
					</div>
					<div class="sixteen wide mobile eight wide tablet eight wide computer right aligned column">
            <template v-if="booking.product.apply_storage_count && booking.product.storage_count < 1">
              <div class="ui fluid red button disabled">{{ $t('modals.availableproducts.not_available') }}</div>
            </template>
            <template v-else>
              <div class="ui fluid blue button" :class="activeMerchant && activeMerchant.opus && !$auth.user().social_number ? 'disabled' : ''" @click="openBookingModal(booking.id)">{{ $t('globals.buttons.reserve') }}</div>
            </template>
					</div>
				</div>
			</div>

			<div class="ui segment" v-if="fetchError">
				<h1>{{ $t('globals.validation.errors.nothing_found') }}</h1>
			</div>
	  </div>

    <paginate
      :page-count="bookings.last_page || 0"
      :page-range="2"
      :margin-pages="1"
      :click-handler="paginate"
      prev-text="Prev"
      prev-class="item"
      next-text="Next"
      next-class="item"
      container-class="ui menu pagination zw-paginate"
      page-class="item">
    </paginate>

    <new-booking-modal :active="showBookingModal" :bookingid="selectedBookingId" :selectedPlace="selectedPlace" v-if="selectedBookingId !== null"
                       @onClose="selectedBookingId = null" @open-image="handleOpenImage" />


    <winter-place-modal v-if="showWinterPlaceModal" :selected-map-element="selectedSpot"
                        @close="showWinterPlaceModal = false" @polygon-selected="handlePolygonSelected"/>
  </div>
</template>

<script>
	import WinterPlaceModal from './WinterPlaceModal.vue';

  export default {
		name: 'AvailableBookings',
    components: {WinterPlaceModal},

		data () {
			return {
				bookings: [],
				currentPage: 1,
				fetchError: null,
				showBookingModal: false,
        showWinterPlaceModal: false,
				selectedBookingId: null,
        selectedPlace: null,
        selectedSpot: {},
			}
		},

		watch: {
			activeMerchant() {
				this.fetchBookings()
			},

			currentPage() {
				this.fetchBookings()
			}
		},

		mounted () {
			this.fetchBookings()
		},

		methods: {
      handleOpenImage(payload) {
        if (payload) {
          this.selectedSpot = payload;
        }
        this.showWinterPlaceModal = true;
      },

      handlePolygonSelected(place) {
        this.selectedPlace = place;
        this.showWinterPlaceModal = false;
      },

			fetchBookings () {
				this.axios.get(`merchants/${this.activeMerchant.id}/bookings`, {
					params: {
						page: this.currentPage,
						perPage: 4
					}
				})
				.then(({data}) => {
					this.bookings = data
					this.fetchError = null
				}, error => {
					this.fetchError = error.response.data
					this.bookings = []
				}).catch()
			},

			openBookingModal (bookingId) {
				this.selectedBookingId = bookingId
				this.$nextTick(() => { this.showBookingModal = !this.showBookingModal })
			},
      paginate (pageNum) {
        this.currentPage = pageNum
      }
		},

		computed: {
			activeMerchant () {
				return this.$store.getters.activeMerchant
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/pages/booking/AvailableBookings.vue